export default __webpack_public_path__ + "static/noel_above_fold2.webp-d0775d6bb5952f6e0f7ad740b76180ea.png";